
























































































import Vue from "vue";
import axios from "axios";
import Modal from "@/components/root/modal/Modal.vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
import { Ref, ref, computed, watch, onMounted } from "@vue/composition-api";
import { getAuditLogConcentUrl } from "@/common/api/integrations.api";
import { ModalConfig } from "../root/modal";
import { AppAnalytics } from "@/analytics";
import { debounce } from "@/fp";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    Modal,
    AppCheckbox,
  },
  setup(props, { emit }) {
    const videoUrl = ref("");
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "76rem", // 76
      height: "34.4rem", // 36.4
      backdropDismiss: false,
    };

    const showExpendedGif = ref(false);
    const toggleGifAnim = debounce(200)(() => {
      showExpendedGif.value = !showExpendedGif.value;
      const videoContainerEl = document.querySelector(
        "#audit-log-video-container"
      ) as HTMLElement;
      const videoEl = document.querySelector("#audit-log-video") as HTMLElement;
      if (showExpendedGif.value) {
        videoEl.animate(
          [
            {
              borderWidth: "5px",
            },
          ],
          {
            duration: 300,
            easing: "ease-out",
            fill: "forwards",
          }
        );
        videoContainerEl.animate(
          [
            {
              width: "100%",
              left: "0%",
            },
          ],
          {
            duration: 300,
            easing: "ease-out",
            fill: "forwards",
          }
        );
      } else {
        videoEl.animate(
          [
            {
              borderWidth: "0px",
            },
          ],
          {
            duration: 300,
            easing: "ease-out",
            fill: "forwards",
          }
        );
        videoContainerEl.animate(
          [
            {
              width: "50%",
              left: "50%",
            },
          ],
          {
            duration: 300,
            easing: "ease-out",
            fill: "forwards",
          }
        );
      }
    });

    const agree = ref(false);

    onMounted(() => {
      videoUrl.value = SharedState.env.value.videoUrl;
    });

    watch(agree, (isAgree: boolean) => {
      if (isAgree) {
        AppAnalytics.report({
          component: "Onboarding",
          eventName:
            "Onboarding_auditlog click on privacy policy and terms of use",
        });
      }
    });

    const poster: Ref<string> = ref(location.origin + "/auditlog-poster.gif");

    const close = () => {
      emit("cancel");
    };

    const disableMsBtn = computed(() => !agree.value);

    const sendUserToConsentUrl = async () => {
      AppAnalytics.report({
        component: "Onboarding",
        eventName: "Onboarding_click on auditlog consent",
      });
      const res = await getAuditLogConcentUrl();
      if (res.success) {
        window.open(res.value, "_self");
      }
    };

    return {
      videoUrl,
      agree,
      disableMsBtn,
      poster,
      config,
      close,
      sendUserToConsentUrl,
      showExpendedGif,
      toggleGifAnim,
    };
  },
});
